'use client';

import { FC, PropsWithChildren, createContext, useState } from 'react';
import { SiteConfigStories } from 'modules/stroyblok/types';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import { ClientPageType } from 'src/app/types';

const defaultValue = {};

interface IGtmData {
  pageType?: ClientPageType;
  fss?: string;
  isSuggestionEvent: boolean;
  productListView: Record<number, IAdaptedListProduct>;
}

export interface ICustomData {
  senderConfiguration?: {
    sender: { name: string; senderId?: string }[];
  };
  showPaypalLogin?: boolean;
  packstation?: boolean;
  addressCheck?: boolean;
  orderIdPrefix?: string;
}

interface SiteConfigStoriesContext extends SiteConfigStories {
  PDPHelperIdx?: { lowerPriceIdx: number; higherPriceIdx: number };
  gtmData?: IGtmData;
  country?: string;
  customData?: ICustomData;
  setGtmData?: (state: (prevFilters: IGtmData) => IGtmData) => void;
  triggerSuggestionEvent?: (value: boolean, fss?: string) => void;
  pageLoading?: boolean;
  togglePageLoading?: (f: boolean) => void;
}

export const SiteConfigContext =
  createContext<SiteConfigStoriesContext>(defaultValue);

export const SiteConfigProvider: FC<
  PropsWithChildren & { value: SiteConfigStoriesContext | null }
> = ({ children, value }) => {
  const [gtmData, setGtmData] = useState<IGtmData>({
    isSuggestionEvent: false,
    productListView: {},
  });
  const [pageLoading, setLoading] = useState(false);

  const triggerSuggestionEvent = (value: boolean, fss?: string) => {
    setGtmData((values) => ({ ...values, isSuggestionEvent: value, fss }));
  };
  const togglePageLoading = (f: boolean) => setLoading(f);

  return (
    <SiteConfigContext.Provider
      value={{
        ...value,
        gtmData,
        setGtmData,
        triggerSuggestionEvent,
        pageLoading,
        togglePageLoading,
      }}
    >
      {children}
    </SiteConfigContext.Provider>
  );
};
